// RecipeForm.jsx
import { Grid2, Paper, TextField, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const RecipeForm = ({ values, setValues, errors }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prev) => ({ ...prev, [name]: value }));
  };

  const renderTextField = (label, props = {}) => {
    const isTimeField = ["prepTime", "cookTime"].includes(label);
    const defaultHelper = isTimeField ? t("tooltips.minutes") : "";
    const showError = !!errors?.[label];

    return (
      <TextField
        name={label}
        label={t(label)}
        value={values[label] || ""}
        onChange={handleChange}
        fullWidth
        margin="normal"
        type={props.type || "text"}
        error={showError}
        helperText={showError ? errors[label] : defaultHelper}
        id={label}
        aria-label={t(label)}
        aria-describedby={`${label}-helper-text`}
        aria-invalid={showError}
        multiline={props.multiline}
        rows={props.rows}
        slotProps={{
          input: {
            ...props.inputProps,
          },
        }}
      />
    );
  };

  return (
    <Paper elevation={3} sx={{ padding: theme.spacing(3), my: theme.spacing(2), borderRadius: theme.shape.borderRadius }}>
      <Grid2 container spacing={2}>
        <Grid2 xs={12} md={6}>
          {renderTextField("title")}
          {renderTextField("description", { multiline: true, rows: 4 })}
        </Grid2>
        <Grid2 xs={12} md={6}>
          <Grid2 container spacing={2}>
            <Grid2 xs={6}>{renderTextField("author")}</Grid2>
            <Grid2 xs={6}>{renderTextField("servings", { type: "number", inputProps: { min: 1 } })}</Grid2>
            <Grid2 xs={6}>{renderTextField("prepTime", { type: "number", inputProps: { min: 1 } })}</Grid2>
            <Grid2 xs={6}>{renderTextField("cookTime", { type: "number", inputProps: { min: 1 } })}</Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    </Paper>
  );
};

export default RecipeForm;
